"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = (0, tslib_1.__importStar)(require("react"));
var ArrowLeftIcon = function (_a) {
    var size = _a.size, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (React.createElement("svg", (0, tslib_1.__assign)({ viewBox: "0 0 13 18", fill: "currentColor", width: size || '13', height: size || '18' }, props),
        React.createElement("g", { id: "Actions_05", stroke: "none", fill: "none", strokeWidth: "1", fillRule: "evenodd" },
            React.createElement("path", { transform: "rotate(-180 6.785 9.017)", d: "M2.56943454 -4.26325641e-14L1 1.59637082 9.90393128 9.01743437 1.16642458 16.5458666 2.56943454 18.0348687 12.5694345 8.9835939z", fill: "currentColor" }))));
};
ArrowLeftIcon.displayName = 'ArrowLeftIcon';
exports.default = ArrowLeftIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ArrowLeftIcon.js.map